import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { InactiveUserError } from '../auth/InactiveUserError';

const AuthSearchSchema = z.object({
    error: z.string().optional().catch(undefined),
});

const AuthCallback = () => {
    return <InactiveUserError />;
};

export const Route = createFileRoute('/auth')({
    validateSearch: (search: Record<string, unknown>) => AuthSearchSchema.parse(search),
    beforeLoad: ({ search }) => {
        if (search.error) {
            if (search.error === 'access_denied' || search.error === 'unauthorized') {
                return;
            }

            throw redirect({
                to: '/login',
                replace: true,
            });
        }

        throw redirect({
            to: '/dashboard',
            replace: true,
        });
    },
    component: AuthCallback,
});
